<template>
  <div class="flex w-full flex-col items-start overflow-hidden py-8 md:items-center" data-testid="storyContentsSection" :class="backgroundColor">
    <div v-for="(storyContent, index) in section.storyContents" :key="`${storyContent.fieldId}-${index}`" class="w-full">
      <h2 v-if="storyContent.fieldId === 'storyContentTitle'" class="px-4 text-center text-2xl text-gold4 md:text-3xl">
        {{ storyContent.title }}
      </h2>
      <div v-if="storyContent.fieldId === 'stories'">
        <StorySliderSection :stories="storyContent.stories" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { type StoryContents } from '@/wabunka-src/common/features/Featured/models/featured/featured';
import StorySliderSection from '@/wabunka-src/common/features/Story/components/StorySliderSection/StorySliderSection.vue';

const props = defineProps<{
  section: StoryContents;
}>();

const backgroundColor = computed(() => {
  switch (props.section.backgroundColor?.[0]) {
    case '白':
      return 'bg-light-bg-default';
    case 'ベージュ':
      return 'bg-light-bg-inset';
    case '深紫':
      return 'bg-dark-bg-default';
    case '黒':
      return 'bg-black';
    default:
      return 'bg-black';
  }
});
</script>
